<div aria-live="assertive"><span *ngIf="errorMessage">{{errorMessage}}</span></div>
